module.exports = __webpack_public_path__ + "img/banner4.cbb65971.png";